import { BasicRequest } from "./basicRequest";

export class AbandonMoovDefinitionRequest extends BasicRequest{
    public moovDefinitionId! : number;
}